import React, { useState } from "react";
import styles from "./ToggleUnixTime.module.scss";
import { formatDate } from "../../utils/formatTime";
import { TxData } from "../../models/Block";
import { IconClock24 } from "@tabler/icons-react";
import { Box } from "@mantine/core";
import { useStore } from "@tanstack/react-store";
import { IStore, store } from "../../services/store.service";

export default function ToggleUnixTime({ time }: { time: string }) {
  const timeZone = useStore<IStore, IStore["timeZone"]>(store, (state) => state.timeZone).selected;
  const [showUnixTime, setShowUnixTime] = useState(false);

  const formatUnixTime = (time: Date): string => {
    const unixTimestamp = time.getTime() / 1000;
    return unixTimestamp.toString();
  };

  return (
    <>
      <Box className={styles.dateWrapperWrapper}>
        <Box className={styles.dateWrapper}>
          {showUnixTime ? (
            <span className={styles.txLabelValue}>
              {formatUnixTime(new Date(time))}
            </span>
          ) : (
            <>
              <span className={styles.txLabelValue}>
                {formatDate(new Date(time), timeZone).formattedDateTime}
              </span>
              &nbsp;
              <span
                onClick={() => setShowUnixTime(!showUnixTime)}
                className={styles.unitLabel}
              >
                {formatDate(new Date(time), timeZone).utcOffset}
              </span>
            </>
          )}
        </Box>
        <div
          onClick={() => setShowUnixTime(!showUnixTime)}
          className={styles.actionIcon}
        >
          <IconClock24 size="20px" color="var(--mid-dark)" />
        </div>
      </Box>
    </>
  );
}
